import { useState, useEffect } from "react"
import { useQuery } from "react-query"
import { useGetToken } from "../../../Hooks/CustomHooks"
import { GetAnioComparativo, SaveAnioComparativo } from "../../../api/Api"
import { Spinner } from "react-bootstrap"
import DatePicker from "react-datepicker"

export default function AnioComparativo({ setSaved }) {

    const token = useGetToken()
    const [comparativeYear, setComparativeYear] = useState(new Date())
    const [getComparativo, setGetComparativo] = useState(true)
    const [saveComparativo, setSaveComparativo] = useState(false)
    const [dateToServer, setDateToServer] = useState(null)

    let { data: dataGetAnioComparativo, isLoading, isError } = useQuery('GetComparativo',
        async () => await GetAnioComparativo({ token: token }),
        {
            enabled: getComparativo
        }
    )

    useEffect(() => {
        if (dataGetAnioComparativo) {
            if (dataGetAnioComparativo.success) {
                let year = parseInt(dataGetAnioComparativo.data.anioComparativo)
                let responseDate = new Date()
                responseDate.setFullYear(year)
                setComparativeYear(responseDate)
                setGetComparativo(false)
            }
        }
    }, [dataGetAnioComparativo])

    let { data: dataSaveAnioComparativo, isLoading: isLoadingSave } = useQuery('SaveComparativo',
        async () => await SaveAnioComparativo({ date: dateToServer, token: token }),
        {
            enabled: saveComparativo
        }
    )

    useEffect(() => {
        if (dataSaveAnioComparativo) {
            if (dataSaveAnioComparativo.success) {
                setSaved(true)
                setSaveComparativo(false)
                localStorage.setItem('anioComparativo', dateToServer)
            }
        }
    }, [dataSaveAnioComparativo])

    return (
        <div className="align-items-end d-flex justify-content-between">
            <div style={{ width: '80%' }}>
                <div className="fw-bold fs-7 text-gray-600 mb-1">Año comparativo global:</div>
                <DatePicker
                    className="form-control form-control-transparent pe-5"
                    locale="es"
                    selected={comparativeYear}
                    onChange={(dateX) => {
                        setComparativeYear(dateX)
                        setDateToServer(dateX.getFullYear())
                    }}
                    dateFormat="yyyy"
                    showYearPicker
                    // minDate={Utilities.add_years(new Date(), -6)}
                    minDate={2017}
                    maxDate={new Date()}
                />
            </div>
            <button type="button" className="btn btn-primary btn-md d-flex ms-2" onClick={() => {
                setSaveComparativo(true)
            }}>
                Guardar
                {isLoadingSave &&
                    <Spinner animation="border" variant="secondary" role="status" className="loading d-flex justify-content-center superadmin-spinner"></Spinner>
                }
            </button>
        </div>
    )
}